var ExternalNotesController = /** @class */ (function () {
    /*@ngInject*/
    function ExternalNotesController(EventEmitter) {
        this.EventEmitter = EventEmitter;
    }
    ExternalNotesController.prototype.$onInit = function () {
        this.addExternalNotes = false;
        this.copyNote = false;
        if (this.addNoteLabel == undefined) {
            this.addNoteLabel = "Add External Notes";
        }
        if (this.copyNoteLabel == undefined) {
            this.copyNoteLabel = "Copy to External Notes";
        }
        if (this.externalNoteLabel == undefined) {
            this.externalNoteLabel = "External Notes";
        }
        if (this.externalNote !== undefined && !_.isNull(this.externalNote) && this.externalNote.length > 0) {
            this.addExternalNotes = true;
        }
    };
    ExternalNotesController.prototype.toggleAddExternalNotes = function () {
        if (!this.addExternalNotes) {
            this.externalNote = "";
            this._externalNoteChanged();
        }
    };
    ExternalNotesController.prototype.toggleCopyToExternalNotes = function () {
        if (this.copyNote) {
            this.externalNote = this.note;
        }
        else {
            this.externalNote = "";
        }
        this._externalNoteChanged();
        this._copyNoteChanged();
    };
    ExternalNotesController.prototype.onExternalNoteChanged = function () {
        this.copyNote = false;
        this._externalNoteChanged();
        this._copyNoteChanged();
    };
    ExternalNotesController.prototype._externalNoteChanged = function () {
        this.onExternalNoteChange(this.EventEmitter({
            externalNote: this.externalNote
        }));
    };
    ExternalNotesController.prototype._copyNoteChanged = function () {
        this.onCopyNoteChange(this.EventEmitter({ copyNote: this.copyNote }));
    };
    ExternalNotesController.prototype.receiveFormalizedComment = function (event) {
        this.externalNote = event;
        this._externalNoteChanged();
    };
    ExternalNotesController.prototype.onVoiceTranscript = function (transcript) {
        if (this.externalNote) {
            this.externalNote += ' ' + transcript;
        }
        else {
            this.externalNote = transcript;
        }
        this._externalNoteChanged();
    };
    return ExternalNotesController;
}());
ExternalNotesController.$inject = ['EventEmitter'];
// import * as TEMPLATE from './external-notes.html';
import * as TEMPLATE from 'raw-loader!./external-notes.html';
export var ExternalNotesComponent = {
    selector: 'externalNotes',
    component: {
        bindings: {
            form: '<',
            note: '<',
            externalNote: '<',
            copyNote: '<',
            addNoteLabel: '@',
            copyNoteLabel: '@',
            externalNoteLabel: '@',
            onExternalNoteChange: '&',
            onCopyNoteChange: '&',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: ExternalNotesController,
        // templateUrl: 'app/shared/externalNotes/external-notes.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=external-notes.component.js.map